import type { AxiosPromise, AxiosResponse } from 'axios';

import { httpClient } from '@/src/shared/services/api.services';
import { API_URLS } from '@/src/shared/services/endpoints/apiUrls';

import type { UserRoleType } from './responseModel';
import type { UserLoginHistoryResponse } from './responseModel/userApiType';

export const updateLoginHistory = async (
    isLogout: boolean
): Promise<AxiosResponse<UserLoginHistoryResponse>> => {
    try {
        const response = await httpClient.post(API_URLS.POST_LOGIN_HISTORY(), {
            isLogout,
        });
        return response?.data;
    } catch (error: any) {
        return error?.cause?.data;
    }
};

export const getUserRolePermissions = async (): Promise<AxiosPromise<UserRoleType>> => {
    try {
        return await httpClient.get(API_URLS.GET_USER_ROLE());
    } catch (error: any) {
        return error?.cause?.data;
    }
};

export const updateReleaseNotesSeen = async (version: string): Promise<AxiosResponse> => {
    try {
        return await httpClient.put(API_URLS.PUT_RELEASE_NOTES(version));
    } catch (error: any) {
        return error?.cause.data;
    }
};

export const getReleaseNotesSeen = async (version: string): Promise<AxiosResponse> => {
    try {
        return await httpClient.get(API_URLS.GET_RELEASE_NOTES(version));
    } catch (error: any) {
        return error?.cause.data;
    }
};

export const getGuidedTourSeen = async (): Promise<AxiosResponse> => {
    try {
        return await httpClient.get(API_URLS.GUIDED_TOUR);
    } catch (error: any) {
        return error?.cause.data;
    }
};

export const updateGuidedTourSeen = async (): Promise<AxiosResponse> => {
    try {
        return await httpClient.put(API_URLS.GUIDED_TOUR);
    } catch (error: any) {
        return error?.cause.data;
    }
};
